import CovidService from '@/services/CovidService'

export const covid = {
  namespaced: true,
  actions: {
    buscarAbrigosporRegiao ({ dispatch }, { agrupamento, periodo }) {
      return CovidService.buscarAbrigosporRegiao({ agrupamento, periodo })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarCasosObitos ({ dispatch }, { inicio, fim }) {
      return CovidService.buscarCasosObitos({ inicio, fim })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarCasosObitosConsolidados ({ dispatch }, { inicio, fim }) {
      return CovidService.buscarCasosObitosConsolidados({ inicio, fim })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarCasosObitosAcumulado ({ dispatch }, { inicio, fim }) {
      return CovidService.buscarCasosObitosAcumulado({ inicio, fim })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarIsolamentoSocial ({ dispatch }, { inicio, fim }) {
      return CovidService.buscarIsolamentoSocial({ inicio, fim })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarAcoesPMSP ({ dispatch }, { inicio, fim }) {
      return CovidService.buscarAcoesPMSP({ inicio, fim })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    buscarDoacoesCidadeSolidaria ({ dispatch }) {
      return CovidService.buscarDoacoesCidadeSolidaria()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

  },
  state: {},
  mutations: {},
}
